/* @flow */

import type { ThermostatModeFeature } from "./types";

export default function ThermostatMode(feature: ThermostatModeFeature) {
  let updateModeAction = feature.actions.update_thermostat_mode;

  this.setThermostatMode = (value, ids = null) => {
    return this.executeDeviceAction(
      updateModeAction,
      {
        value,
        ids,
      },
      { fetchModelWhenDone: true }
    );
  };

  return {
    thermostatMode: {
      name: feature.name,
      label: feature.label,
      options: feature.options,
      value: feature.value,
      displayValue: feature.display_value,
    },
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/thermostat_mode.js